import { ReceiptDetailPanelVariant } from "./shared/ReceiptDetailPanelVariant";
import newProduct from "./images/newProduct.png";
import { receiptDetailExamplesTamaris } from "./ReceiptDetailExamplesTamaris";

export const ReceiptDetailPanelTamaris = () => (
  <ReceiptDetailPanelVariant
    examples={receiptDetailExamplesTamaris}
    imageFolder="productImagesTamaris"
    badgeIcon={newProduct}
    badgeAlt="Bio-zertifiziert"
    badgeTitle="Bio-zertifiziert"
  />
);
